import moment from 'moment';
import { getMetricsMapping, formatNumber } from '../utils';

export const getTableColumns = () => [
  {
    title: '#',
    key: 'index',
    width: 50,
    cellRenderer: ({ rowIndex }) => rowIndex + 1,
  },
  {
    title: 'CDN',
    dataKey: 'resource',
    key: 'resource',
    sortable: true,
    resizable: true,
    width: 175,
  },
  {
    title: 'ISP',
    dataKey: 'asnname',
    key: 'asnname',
    sortable: true,
    resizable: true,
    width: 175,
  },
  {
    title: 'DMA',
    dataKey: 'dmaname',
    key: 'dmaname',
    sortable: true,
    resizable: true,
    width: 175,
  },
  {
    title: 'Policy',
    dataKey: 'policy',
    key: 'policy',
    sortable: true,
    resizable: true,
    width: 300,
  },
  {
    title: 'Start Time',
    dataKey: 'starttime',
    key: 'starttime',
    sortable: true,
    resizable: true,
    width: 175,
  },
  {
    title: 'Duration (min)',
    dataKey: 'totaltime',
    key: 'totaltime',
    sortable: true,
    resizable: true,
    align: 'center',
    width: 125,
  },
  {
    title: 'Trigger KPI',
    dataKey: 'triggerkpi',
    key: 'triggerkpi',
    sortable: true,
    resizable: true,
    width: 150,
  },
  {
    title: 'Blacklisted KPI',
    dataKey: 'blacklistedkpi',
    key: 'blacklistedkpi',
    sortable: true,
    resizable: true,
    width: 125,
  },
  {
    title: 'Reference KPI',
    dataKey: 'referencekpi',
    key: 'referencekpi',
    sortable: true,
    resizable: true,
    width: 125,
  },
  {
    title: 'KPI Sample Size',
    dataKey: 'kpisamplesize',
    key: 'kpisamplesize',
    sortable: true,
    resizable: true,
    width: 150,
  },
];

export const formatTableData = (data) => {
  const metricMapping = getMetricsMapping();
  return data.slice(0, 100).map((item) => {
    const metricName = metricMapping[item.triggerkpi];
    return {
      resource: item.resource,
      asn: item.asn,
      asnname: `${item.asn} -  ${item.asnname}`,
      dmaname: `${item.dma} -  ${item.dmaname}`,
      policy: item.policy,
      starttime: moment(item.starttime, 'YYYY-MM-DD HH:mm:ss.SSS').format('YYYY-MM-DD HH:mm:ss'),
      triggerkpi: metricName,
      totaltime: formatNumber(item.totaltime),
      blacklistedkpi: formatNumber(item.blacklistedkpi),
      referencekpi: formatNumber(item.referencekpi),
      kpisamplesize: formatNumber(item.kpisamplesize),
    };
  });
};
